<template>
  <v-dialog v-model="dialog" max-width="420">
    <template>
      <v-card class="py-2">
        <v-card-title class="title justify-center" v-translate>
          {{ options.cardTitle }}
        </v-card-title>
        <v-card-text class="modal-description" v-translate>
          {{ options.cardText }}
        </v-card-text>
        <v-card-actions class="mt-5 d-flex flex-column align-center">
          <v-btn text @click="close(false)">
            <translate>{{ options.cancelButtonText }}</translate>
          </v-btn>

          <v-btn text @click="close(true)" class="ml-0">
            <translate>{{ options.approveButtonText }}</translate>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',

  data() {
    return {
      dialog: false,
      resolve: null,
      options: {
        cancelButtonText: 'Don\'t submit the Award',
        approveButtonText: 'Submit the Award now',
        cardText: 'Please confirm that you want to submit this Award.',
        cardTitle: 'Submission Confirmation',
      },
    }
  },

  created() {
    this.$root.openConfirmDialog = this.open;
  },

  methods: {
    open(options) {
      if (options) {
        const { cancelButtonText, approveButtonText, cardText, cardTitle } = options;
        this.options.cancelButtonText = cancelButtonText;
        this.options.approveButtonText = approveButtonText;
        this.options.cardText = cardText;
        this.options.cardTitle = cardTitle;
      }
      this.dialog = true;
      return new Promise(resolve => {
        this.resolve = resolve;
      });
    },

    close(result) {
      this.resolve(result);
      this.dialog = false;
    }
  }
}
</script>

<style scoped>

</style>
